import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { billingKeys } from '../queries/keys';
import { billingPaths } from '../queries/paths';

// TSS vite/03 — ajustes/exchanges por vaca-período (admin-billing-exchanges.md):
// charge (cargo, el dueño debe) o credit (haber, se le acredita, p.ej. leche). El
// `amount` lo deriva el servidor (unit_cost × quantity). Permiso billing:*.

export function useCreateExchange() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => api.post(billingPaths.exchanges(), payload).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: billingKeys.all }),
    });
}

export function useDeleteExchange() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => api.delete(billingPaths.exchange(id)).then(r => r.data),
        onSuccess:  () => qc.invalidateQueries({ queryKey: billingKeys.all }),
    });
}
